import React, { useEffect } from "react";
import { Box, Text, Image, Button } from "@chakra-ui/react";
import Typewriter from "typewriter-effect";
import img from "./images/prince.png";
import Aos from "aos";
import back from "./images/back.jpg"
import cv from "./images/Prince_Singh_Resume_new.pdf"
import "aos/dist/aos.css";
const Home = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  const goto = ()=>{
    window.open("https://drive.google.com/file/d/142LD5wD4ruf4Mo2np9CKQweA5s0GbBE0/view?usp=sharing")
  }

  return (
    <Box>
      <Box p="50px 0px" pt="140px" id="Home">
        <Box
          w="85%"
          display={["inline", "inline", "flex"]}
          m="auto"
          p="40px 0px"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box textAlign="left" w={["85%", "85%", ""]} m={["auto", "auto", ""]}>
            <Text fontFamily="Serif" fontSize={["3xl", "4xl", "5xl"]}>
              Hi there👋  
            </Text>
            <Text fontFamily="Serif" fontSize={["4xl", "5xl", "6xl"]}>
              I'm Prince Singh
            </Text>
            <Box fontFamily="Serif" fontSize={["2xl", "3xl", "4xl"]}>
              <Typewriter
                options={{
                  strings: [
                    "I'm a Full Stack Web Developer.",
                    "I'm a Mern Developer",
                    "I'm a Backend Developer.",
                  ],
                  autoStart: true,
                  loop: true,
                  deleteSpeed: 80,
                  fontFamily: "Serif",
                }}
              />
              <Box w={[250, 300, 400, 600]}>
                <Text
                  fontFamily="Serif"
                  mb="40px"
                  mt="10"
                  fontSize={["15px", "22px", "15px"]}
                  textAlign="justify"
                >
                  An aspiring Full Stack Web Developer💻. Capable of writing
                  optimized code using React JS, Redux, HTML, and CSS on the
                  front end and NodeJS, ExpressJS, and MongoDB on the backend to
                  build single-page applications and 300+ Hours of DSA a team
                  player who is proficient in working with a team.
                </Text>
              </Box>
            </Box>
            <a  download
                    _hover={{ textDecoration: "none" }}
                    href={cv}
                    
                  >
                <Button
                colorScheme='linkedin'
                _hover={{
                  transform: "scale(1.05)",
                  transition: "transform, 0.5s",
                }}
                  onClick={goto}
                  p={["10px", "25px", "10px"]}
                  mt="25px"
                  fontSize={["lg", "xl", "2xl"]}
                  mb="25px"
                >
                    Resume
               
                </Button>
                </a>
          </Box>
          <Box w={["55%", "50%", "35%"]} m={["auto", "auto", ""]}>
            <Image borderRadius="10%" _hover={{
            border:"none",
            textDecoration: "none" ,
            transitionDuration: "1000ms",
            transform:"scale(1.1)",
            cursor:"pointer",
          
          }} src={img} alt="img" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
